import React, { lazy } from 'react'
import { IonIcon } from './IonIcon'
import _ from 'lodash'
import { SuspenseLoader } from '../../../Web/WebLoader'

const MuiIcon = lazy(() => import('./MuiIcon' /* webpackChunkName: "all-icons" */))

export default function Icon({ icon, color, size, ...rest }) {
  if (_.startsWith(icon, 'ion##')) {
    return <IonIcon icon={icon} color={color} size={size} {...rest} />
  } else {
    return (
      <SuspenseLoader>
        <MuiIcon icon={icon} color={color} size={size} {...rest} />
      </SuspenseLoader>
    )
  }
}
